import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconComponent } from './ui/icon.component';
import { AnimateDirective } from '../directives/animate.directive';

@Component({
  selector: 'app-risk',
  imports: [CommonModule, IconComponent, AnimateDirective],
  template: `
    <section id="risk" class="flex flex-col justify-center py-16 md:py-24 bg-[#111111] relative overflow-hidden">
       <!-- Subtle pattern -->
      <div class="absolute inset-0 hexagon-bg opacity-30"></div>
      <!-- Tech Background Overlay -->
      <div class="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-gray-800/20 via-[#111111] to-[#111111] pointer-events-none"></div>

      <div class="container mx-auto px-4 md:px-6 relative z-10">
        <div class="max-w-5xl mx-auto text-center mb-12">
          <h2 appAnimate class="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6 leading-tight">
            O que sua empresa arrisca ao ignorar o controle da pausa térmica?
          </h2>
          <p appAnimate [delay]="100" class="text-gray-300 text-lg md:text-xl font-light">
            A legislação trabalhista é clara e a fiscalização está cada vez mais rigorosa.
          </p>
        </div>

        <div class="grid md:grid-cols-3 gap-8">
          <!-- Card 1: A Regra -->
          <div appAnimate [delay]="200" class="h-full">
            <div class="bg-[#1c1c1c] border border-white/5 rounded-2xl p-8 hover:border-[#FF5500]/50 transition-all duration-300 group flex flex-col hover:shadow-2xl hover:shadow-[#FF5500]/5 h-full">
               <div class="w-14 h-14 rounded-xl bg-[#111111] border border-white/10 flex items-center justify-center text-[#FF5500] mb-6 group-hover:scale-110 transition-transform shadow-lg group-hover:bg-[#FF5500]/10 group-hover:border-[#FF5500]/20">
                 <app-icon name="clock" [size]="32"></app-icon>
               </div>
               <h3 class="text-xl font-bold text-[#FF5500] mb-3">A regra é clara</h3>
               <p class="text-white leading-relaxed text-base">
                 A cada 1h40 em ambiente abaixo de 15 graus, o colaborador precisa descansar 20 minutos em ambiente aquecido.
               </p>
            </div>
          </div>

          <!-- Card 2: O Risco -->
          <div appAnimate [delay]="400" class="h-full">
            <div class="bg-[#1c1c1c] border border-white/5 rounded-2xl p-8 hover:border-red-500/50 transition-all duration-300 group flex flex-col hover:shadow-2xl hover:shadow-red-500/5 h-full">
               <div class="w-14 h-14 rounded-xl bg-[#111111] border border-white/10 flex items-center justify-center text-red-500 mb-6 group-hover:scale-110 transition-transform shadow-lg group-hover:bg-red-500/10 group-hover:border-red-500/20">
                 <app-icon name="shield-alert" [size]="32"></app-icon>
               </div>
               <h3 class="text-xl font-bold text-[#FF5500] mb-3">O risco é alto</h3>
               <p class="text-white leading-relaxed text-base">
                 Ações trabalhistas com custos elevados e baixa produtividade por parte do colaborador devido ao cansaço e problemas de saúde.
               </p>
            </div>
          </div>

          <!-- Card 3: A Solução -->
          <div appAnimate [delay]="600" class="h-full">
            <div class="bg-[#1c1c1c] border border-white/5 rounded-2xl p-8 hover:border-green-500/50 transition-all duration-300 group flex flex-col hover:shadow-2xl hover:shadow-green-500/5 h-full">
               <div class="w-14 h-14 rounded-xl bg-[#111111] border border-white/10 flex items-center justify-center text-green-500 mb-6 group-hover:scale-110 transition-transform shadow-lg group-hover:bg-green-500/10 group-hover:border-green-500/20">
                 <app-icon name="check-circle" [size]="32"></app-icon>
               </div>
               <h3 class="text-xl font-bold text-[#FF5500] mb-3">A solução é simples</h3>
               <p class="text-white leading-relaxed text-base">
                 Custo acessível, fácil instalação, aumento de produtividade e segurança jurídica.
               </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  `
})
export class RiskComponent { }